var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 14.8947L17.5 10.728M17.5 10.728L13.3333 6.56136M17.5 10.728H7.5M7.5 3.22803H6.5C5.09987 3.22803 4.3998 3.22803 3.86502 3.50051C3.39462 3.74019 3.01217 4.12265 2.77248 4.59305C2.5 5.12783 2.5 5.8279 2.5 7.22803V14.228C2.5 15.6282 2.5 16.3282 2.77248 16.863C3.01217 17.3334 3.39462 17.7159 3.86502 17.9555C4.3998 18.228 5.09987 18.228 6.5 18.228H7.5",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.3c52a77bf50873eb0887a9c3eb3c2584.svg";
export { ForwardRef as ReactComponent };